<template>
  <div class="VideoPlaypage">
    <div class="VideoPlaypage_top">
      <h3 class="page_title">
        <span class="back" @click="goBack"><i class="el-icon-d-arrow-left"></i>返回</span>
        {{detail.title}}</h3>
      <div class="page_main">
        <video id='tkwrap' class='video-js vjs-big-play-centered page_video' ref="videoPlayer"></video>
        <div class="TOC_box" id="TOC_box">
          <div class="title">课程目录</div>
          <div v-for="(chapter,i) in chapterList" :key="i" class="chapter_class">
            <!--       章节信息       -->
            <div class="chapter_t" @click="handleChildren(chapter,i)">
              <div class="chapter_t_l">
                <i v-show="!chapter.IsOpen" class="el-icon-caret-right"></i>
                <i v-show="chapter.IsOpen" class="el-icon-caret-bottom"></i>
                <span class="chapter_t_l_span1">{{chapter.title}}</span>
                <span class="chapter_t_l_span2">（ {{chapter.lessons ? chapter.lessons.length : 0}}小节 ）</span>
              </div>
              <span class="chapter_t_r" v-if="chapter.status == 2">已学完<i class="el-icon-circle-check"></i></span>
            </div>
            <!--      节信息        -->
            <div v-show="chapter.lessons && chapter.lessons.length && chapter.IsOpen">
              <div v-for="(lesson, index) in chapter.lessons" :key="index" class="lesson_class"
                   :style="{backgroundColor: contentObj.asset_id == lesson.asset_id ? '#fbf2ec':''}"
                   @click="changeLesson(lesson)" :id="'lesson_'+lesson.id">
                <div class="lesson_t">{{lesson.sort}}、{{lesson.title}}</div>
                <div class="lesson_t_b">
                  <span class="lesson_btn">视频</span>
                  <span class="lesson_t_b__">|</span>
                  <span class="lesson_t_b_time">{{lesson.time}}</span>
                  <span class="lesson_t_b__">|</span>
                  <span v-show="lesson.id != contentObj.id" style="font-size: 14px;" :style="{color:lesson.status==1?'#999':'#10B981'}">{{lesson.study_view}}<i v-show="lesson.status == 2" class="el-icon-circle-check"></i></span>
                  <span style="color: #FF6E17;font-size: 16px" v-show="lesson.id == contentObj.id">学习中</span>
                </div>
                <span class="last_study" v-if="lastStudy && lastStudy.id == lesson.id"><i class="el-icon-time"> 上次学习</i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="VideoPlaypage_bottom">
      <h3 class="content_t">{{contentObj.title}}</h3>
      <div class="content_t_c">
        <span v-html="contentObj.content"></span>
      </div>
    </div>
  </div>
</template>
<script>
import { loadScriptsInOrder } from '../../utils/loadScripts';
export default {
  name: 'VideoPlay',
  data() {
    return {
      chapterList:[],
      detail:{},
      lastStudy:{},
      player:null,
      playerConfig:null,
      vid:null,
      contentObj:{},
      flag:false
    }
  },
  async created () {
    const scripts = [
      'https://h5-static.talk-cloud.net/static/frame_vodPlayer_1.3.0.11/hls.min.js',
      'https://h5-static.talk-cloud.net/static/frame_vodPlayer_1.3.0.11/tcplayer.js',
      'https://h5-static.talk-cloud.net/static/frame_vodPlayer_1.3.0.11/tkPlayer.js'
    ];
    try {
      await loadScriptsInOrder(scripts);
    } catch (error) {
    }
    await this.getDetail()
  },
  beforeDestroy () {
    try {
      this.player.dispose()
    } catch(e) {
    }
  },
  methods: {
    scrollToLesson(id){
      setTimeout(()=>{
        console.log('lesson_'+id)
        const pDiv = document.getElementById('TOC_box');
        const target = document.getElementById('lesson_'+id);
        // 获取目标元素相对于父容器（myDiv）的顶部距离
        const targetTop = target.offsetTop;

        // 滚动到目标元素位置（平滑滚动）
        pDiv.scrollTo({
          top: targetTop-200,//还有顶部课程目录的高度
          behavior: 'smooth'
        });
      })
    },
    goBack(){
      this.$router.go(-1)
    },
    //下一个
    changeLesson(lesson){
      this.$set(this,'vid',lesson.asset_id)
      this.contentObj = lesson
      this.flag = false
      if (!this.player) return
      this.player.upDateVid(lesson.asset_id);
      this.getDetail(false)
    },
    initPlayer(){
      let _self = this
      console.error('this', this.player)
      if(tkPlayer && this.vid){
        tkPlayer({
          vid: this.vid ? this.vid : '5145403704937204332',
          wrap: '#tkwrap',//容器节点id
          companyId: _self.playerConfig.companyId ? _self.playerConfig.companyId : 122639,//必传
          userId:_self.playerConfig.userId,
          userName:_self.playerConfig.nickname,
          language: 'zh-cn',
        }, (player) => {
          _self.player = player;
          window.player = player
          this.onEvent()
        });
      }else {
        setTimeout(()=>{
          tkPlayer({
            vid: this.vid ? this.vid : '5145403704937204332',
            wrap: '#tkwrap',//容器节点id
            companyId: _self.playerConfig.companyId ? _self.playerConfig.companyId : 122639,//必传
            userId:_self.playerConfig.userId,
            userName:_self.playerConfig.nickname,
            language: 'zh-cn',
          }, (player) => {
            _self.player = player;
            window.player = player
            this.onEvent()
          });
        })
      }
    },
    onEvent() {
      let that = this
      if (!this.player) return
      this.player.on('ended', this.handlerEnded.bind(this))//结束
      this.player.on('pause', this.handlerPause.bind(this))//暂停
      this.player.on('play', this.handlerPlay.bind(this))//开始
      this.player.on('loadedmetadata', () => { //持续播放
        clearInterval(that.regularlyReportTimer)
        that.regularlyReportTimer = null;
        if(that.lastStudy && that.lastStudy.asset_id == that.contentObj.asset_id && that.lastStudy.last_lession_time){
          if(that.contentObj.last_lession_time > that.lastStudy.last_lession_time){
            that.player.currentTime(that.contentObj.last_lession_time)
          }else{
            that.player.currentTime(that.lastStudy.last_lession_time)
          }
        }else if(that.contentObj && that.contentObj.last_lession_time){
          that.player.currentTime(that.contentObj.last_lession_time)
        }else{
          that.player.currentTime(0)
        }
        this.player.play()
      })
    },
    handlerEnded() {
      clearInterval(this.regularlyReportTimer)
      this.regularlyReportTimer = null;
      this.uploadProgress('end');
    },

    handlerPause() {
      clearInterval(this.regularlyReportTimer)
      this.regularlyReportTimer = null;
      this.uploadProgress()
    },

    handlerPlay() {
      clearInterval(this.regularlyReportTimer)
      this.regularlyReportTimer = null;
      this.regularlyReportTimer = setInterval(() => {
        this.uploadProgress();
      }, 5000)
    },
    async uploadProgress(type) {
      if (!this.player) return
      await this.$http.post('/api/vodLesson/' + this.contentObj.id,{
        status:type && this.flag ? 2 : 1,
        time:~~this.player.currentTime(),
        duration: this.player.duration()
      }).then(res => {
        if(res.data.code != 200){
          this.$message.error(res.data.msg)
        }else {
          let s = (this.player.duration() * 0.7).toFixed(0)
          let r = ~~this.player.currentTime()
          if(r >= s && !this.flag){
            this.flag = true
            this.getDetail(false)
          }
        }
      })
    },
    getFastVid(){
      for (let i = 0; i < this.chapterList.length; i++) {
        let item = this.chapterList[i]
        if(item.lessons){
          for (let j = 0; j < item.lessons.length; j++) {
            let jtem = item.lessons[j]
            if(jtem.asset_id)return jtem.asset_id
          }
        }
      }
    },
    getFastLesson(){
      for (let i = 0; i < this.chapterList.length; i++) {
        let item = this.chapterList[i]
        if(item.lessons){
          for (let j = 0; j < item.lessons.length; j++) {
            let jtem = item.lessons[j]
            return jtem
          }
        }
      }
    },
    async getDetail(isInit = true){
      await this.$http.get('/api/vodChapterLessons/' + this.$route.query.id).then(async res => {
        if(res.data.code == 200){
          this.chapterList = res.data.data.chapters
          this.detail = res.data.data.detail
          this.lastStudy = res.data.data.lastStudy[0]
          this.playerConfig = res.data.data.player
          this.chapterList.map((ele, index) => {
            if (ele) {
              ele.IsOpen = true
            }
          })
          if(isInit){
            if (this.$route.query.type == 1) {
              //开始学习
              this.vid = this.getFastVid()
              this.contentObj = this.getFastLesson()
            } else if (this.$route.query.type == 2) {
              //继续学习
              this.vid = this.lastStudy.asset_id
              this.contentObj = this.lastStudy
            } else {
              //点击的下方章节进行的跳转
              this.vid = JSON.parse(sessionStorage.getItem('startStudy')).asset_id
              this.contentObj = JSON.parse(sessionStorage.getItem('startStudy'))
            }
            this.$set(this, 'vid', this.vid)
            this.$set(this, 'contentObj', this.contentObj)
            this.scrollToLesson(this.contentObj.id)
            await this.initPlayer()
          }
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //点击章节展开收起
    handleChildren(chapter,i){
      chapter.IsOpen = !chapter.IsOpen
      this.$set(this.chapterList,i,chapter)
    },
  }
}
</script>

<style scoped>
@import "https://h5-static.talk-cloud.net/static/frame_vodPlayer_1.3.0.11/tkPlayer.css";

.VideoPlaypage{
  padding: 12px;
  background-color: #f8f8f8;
}
.VideoPlaypage_top{
  padding: 16px 12px 12px 12px;
  border-radius: 4px;
  background-color: #fff;
}
.VideoPlaypage_bottom{
  padding: 16px;
  background-color: #fff;
  margin-top: 12px;
  border-radius: 4px;
  min-height: calc(100vh - 686px);
}
.page_title{
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 16px;
}
.page_main{
  display: flex;
  flex-direction: row;
}
@media screen and (min-width: 1660px) {
  .page_video{
    width: 1320px;height: 742px;
    border: 1px solid #999;
  }
  .TOC_box{
    margin-left: 16px;
    width: calc(100vw - 1386px);
    height: 742px;
    overflow-y: auto;
    min-width: 500px;
  }
}
@media screen and (max-width: 1660px) {
  .page_video{
    width: 960px;height: 540px;
    border: 1px solid #999;
  }
  .TOC_box{
    margin-left: 16px;
    width: calc(100vw - 1026px);
    height: 542px;
    overflow-y: auto;
    min-width: 450px;
  }
}


.TOC_box .title{
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 8px;
}
.chapter_class{
  margin-top: 8px;
}
.chapter_t{
  background-color: #FBF2EC;
  display: flex;
  align-items: center;
  height: 64px;
  line-height: 30px;
  justify-content: space-between;
  padding: 20px 16px;
  color: #333;
  box-sizing: border-box;
  cursor: pointer;
  flex-direction: row;
}
.lesson_class{
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}
.lesson_btn{
  /* 自动布局 */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 8px;
  background: rgba(255, 110, 23, 0.2);
  box-sizing: border-box;
  border: 1px solid #FFAC7A;
  width: 44px;
  height: 22px;
  color: #FF6E17;
  font-size: 12px;
  border-radius: 2px;
}
.last_study{
  position: absolute;
  display: inline-block;
  background-color: #FF6E17;
  color: #fff;
  right: 0;
  top: 0;
  font-size: 12px;
  width: 82px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 0px 4px 0px 12px;
}
html, body, .video-js {
  margin: 0;padding: 0;
}
.back{
  display: inline-block;margin-right: 20px;cursor: pointer;font-size: 20px;
}
.chapter_t_l{
  display: flex;flex-direction: row;align-items: center;
}
.chapter_t_l_span1{
  font-size: 16px;display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;width: 75%;
}
.chapter_t_l_span2{
  font-size: 16px;min-width: 80px;
}
.chapter_t_r{
  font-size: 14px;color: #10B981
}
.lesson_t{
  font-size: 16px;  display: -webkit-box;line-height: 16px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lesson_t_b{
  color: #d8d8d8;display: flex;flex-direction: row;margin-top: 8px;align-items: center;
}
.lesson_t_b__{
  display: inline-block;margin: 0 16px;
}
.lesson_t_b_time{
  color: #999;font-size: 16px;
}
.content_t{
  font-size: 14px;font-weight: 500;color: #333333;margin-bottom: 12px;line-height: 24px;
}
.content_t_c{
  color: #666;font-size: 14px;line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/VideoPlay.vue